export default function ShippingSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
          <div>
            <span className="text-sm font-semibold text-primary-600 tracking-wider uppercase">Shipping</span>
            <h2 className="mt-3 text-2xl md:text-3xl font-bold text-foreground-950">
              AllChinaBuy Shipping Guide
            </h2>
            <p className="mt-4 text-base text-foreground-600 leading-relaxed">
              Shipping costs can vary depending on parcel weight, destination, shipping method, dimensions and current carrier conditions. Use our AllChinaBuy shipping resources to understand the main cost factors before preparing a parcel.
            </p>
            <div className="mt-6 flex flex-col sm:flex-row gap-3">
              <a
                href="/allchinabuy-shipping/"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white font-medium rounded-lg hover:bg-primary-600 transition-colors"
              >
                View AllChinaBuy Shipping Cost Guide
                <i className="ri-arrow-right-line" />
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-6 py-3 bg-white text-foreground-700 font-medium rounded-lg border border-background-200 hover:border-primary-300 transition-colors"
              >
                Visit Main Website
                <i className="ri-external-link-line" />
              </a>
            </div>
          </div>
          <div className="relative rounded-xl overflow-hidden aspect-[4/3]">
            <img
              src="https://readdy.ai/api/search-image?query=Cardboard%20shipping%20boxes%20of%20different%20sizes%20stacked%20with%20bubble%20wrap%20and%20packing%20tape%20on%20light%20grey%20warehouse%20table%2C%20warm%20natural%20light%2C%20soft%20shadows%2C%20minimal%20logistics%20product%20photography%2C%20clean%20commercial%20style&width=800&height=600&seq=shipping-img-2026&orientation=landscape&nocache=true"
              alt="Shipping Guide"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}